import posthog from "posthog-js";
import { projectSelector } from "@rflocal/shared";
import { AnalyticsAbstractAdapter } from "./abstract";
import { AnalyticsMethod, AnalyticsEventData } from "../types";

export class PostHogAnalyticsAdapter extends AnalyticsAbstractAdapter {
    protected readonly enabledMethods: AnalyticsMethod[] = Object.values(AnalyticsMethod);

    protected postEvent({
        method,
        id,
        data
    }: {
        method: AnalyticsMethod;
        id?: string;
        data: AnalyticsEventData;
    }) {
        const posthogConfig = projectSelector.posthogConfig?.();
        if (!posthogConfig?.enabled || !posthogConfig.apiKey) {
            return;
        }

        if (projectSelector.isLocal()) {
            console.log(`🧷 [Analytics] ${this.adapterName}`, method, id, data);
            return;
        }

        if (method === AnalyticsMethod.PAGE) {
            return posthog.capture("$pageview", { ...data, page: id });
        }

        if (method === AnalyticsMethod.IDENTIFY) {
            if (!id) return;
            return posthog.identify(id, data);
        }

        if (!id) return;
        return posthog.capture(id, data);
    }
}
